import React from 'react';
import styled, { keyframes } from 'styled-components';

const scale = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
`;

const Button = styled.a`
	display: inline-block;
	animation: ${scale} 1.5s infinite;
	text-transform: uppercase;
	background-color: #FFE8DB;
	text-decoration: none;
	border-radius: 4px;
	font-weight: bold;
	padding: 8px 14px;
	color: black;
	
`;

const GetBlidzButton = () => {
	return (
		<Button
			href="https://get.blidz.com"
			target="_blank"
			rel="noopener noreferrer"
		>
			Get Blidz
		</Button>
	);
};

export default GetBlidzButton;



// WEBPACK FOOTER //
// ./src/components/GetBlidzButton.js